import React from 'react';

import DeleteModal from 'components/modal/DeleteModal';
import { useTranslation } from 'configs/translationContext';
import PropTypes from 'prop-types';

const LabelsByContentType = {
  ALL: {
    title: 'content_list.delete_modal.content.title_all',
    description: 'content_list.delete_modal.content.description',
    confirmLabel: 'general.delete_content_module_confirm_all'
  },
  MODULE: {
    title: 'content_list.delete_modal.module.title',
    description: 'content_list.delete_modal.module.description',
    confirmLabel: 'general.delete_content_module_confirm'
  },
  PAGE: {
    title: 'content_list.delete_modal.page.title',
    description: 'content_list.delete_modal.page.description',
    confirmLabel: 'general.delete_content_module_confirm'
  },
  CONTENT: {
    title: 'content_list.delete_modal.content.title',
    description: 'content_list.delete_modal.content.description',
    confirmLabel: 'general.delete_content_module_confirm'
  }
};

const ContentDeleteModal = ({
  numModules,
  numPages,
  allModules,
  onCancel,
  onConfirm
}) => {
  const { t } = useTranslation();

  const getLabels = () => {
    if (allModules) {
      return LabelsByContentType.ALL;
    }

    if (numModules > 0 && numPages === 0) {
      return { ...LabelsByContentType.MODULE, count: numModules };
    }

    if (numModules === 0 && numPages > 0) {
      return { ...LabelsByContentType.PAGE, count: numPages };
    }

    return LabelsByContentType.CONTENT;
  };

  const { title, description, confirmLabel, count } = getLabels();

  return (
    <DeleteModal
      isOpen
      onCancel={onCancel}
      onConfirm={onConfirm}
      confirmLabel={confirmLabel}
      title={t(title, { data: { count }, amountToPluralize: count })}
      description={
        <>
          {t(description, { data: { count }, amountToPluralize: count })}{' '}
          {t('general.irreversible_action_2')}
        </>
      }
    />
  );
};

ContentDeleteModal.propTypes = {
  numModules: PropTypes.number.isRequired,
  numPages: PropTypes.number.isRequired,
  allModules: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default ContentDeleteModal;
